import { useEffect } from 'react';
import i18next from 'i18next';
import HistoryBanner from './HistoryBanner';
import HistoryHighlights from './HistoryHighlights';
import HistoryDisplay from './HistoryDisplay';
import HistoryLegacy from './HistoryLegacy';
import { useRecapTranslationsQuery } from '../../../services/HistoryPageServices';
import { updatePageview } from '../../../helpers/cxDataLayer';

const preloadImage = (src: string) => {
  if (!src) return;

  const image = new Image();
  image.decoding = 'async';
  image.src = src;
};


function HistoryPage() {
  const recapQuery = useRecapTranslationsQuery();
  const lang = window.location.pathname.slice(1,6);

  useEffect(() => {
    updatePageview({
      name: 'HACKATHON/HISTORY',
      language: lang.split('_')[0],
      country: lang.split('_')[1],
      locale: lang
    });
  }, [lang]);

  useEffect(() => {
    if (!recapQuery.data || recapQuery.data.length === 0) {
      return;
    }

    const currentRecapTranslations = recapQuery.data.find((translation) => translation.languages_code === i18next.language) ?? recapQuery.data[0];
    const displayImages = currentRecapTranslations.display_card.slice(0, 2).map((card) => card.image);
    const legacyImages = currentRecapTranslations.legacy_card.slice(0, 4).map((card) => card.legacy_card_image || card.image || '');

    [currentRecapTranslations.cover_image, ...displayImages, ...legacyImages].forEach(preloadImage);
  }, [recapQuery.data]);

  return (
    <div>
      {<HistoryBanner />}
      {/* {<HistoryHighlights />} */}
      {<HistoryLegacy />}
      {<HistoryDisplay />}

    </div>
  );
}

export default HistoryPage;
